<template>
  <nav class="top-menu">
    <el-menu
      mode="horizontal"
      :default-active="activeMenu"
      :background-color="theme.navFirstBg"
      :text-color="theme.navFirstColor"
      :active-text-color="theme.navFirstActiveColor"
    >
      <template v-for="route in visibleRoutes">
        <el-menu-item
          v-if="route.children && route.children.length === 1"
          :key="route.path == '/' ? '/workbench' : route.path"
          :index="route.path == '/' ? '/workbench' : route.path"
          @click="handleMenuClick(route)"
        >
          <svg-icon v-if="route.meta && route.meta.icon" :icon-class="route.meta.icon" />
          <span>{{ route.meta.title }}</span>
        </el-menu-item>
        <el-submenu
          v-else-if="route.children && route.children.length > 1"
          :key="route.path"
          :index="route.path"

        >
          <template #title>
            <svg-icon v-if="route.meta && route.meta.icon" :icon-class="route.meta.icon" />
            <span>{{ route.meta.title }}</span>
          </template>
          <el-menu-item
            v-for="child in visibleChildRoutes(route)"
            :key="child.path"
            :index="child.path"
            @click="handleMenuClick(child)"
          >
            <svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon" />
            <span>{{ child.meta.title }}</span>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TopMenu',
  computed: {
    ...mapGetters({
      routes: 'routes/routes',
      theme: 'settings/theme'
    }),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    visibleRoutes() {
      return this.routes.filter(route => !route.hidden)
    },

  },
  methods: {
    // 根据父id 查询 path
    getParentPath(id) {
      if(!id){
        return ''
      }
      const parent = this.routes.find(route => route.id === id)
      if(parent && parent.parentId){
        return this.getParentPath(parent.parentId) + this.pathFmt(parent.path)
      }
      if (parent) {
        return this.pathFmt(parent.path)
      }
      return ''
    },
    // 是否/开头 没有则补充
    pathFmt(path) {
      if (path.startsWith('/')) {
        return path
      }
      return '/' + path
    },
    handleMenuClick(route) {
      if (route.path.startsWith('http')) {
        window.open(route.path)
      } else {
        const fullPath = this.getParentPath(route.parentId) + this.pathFmt(route.path)
        this.$router.push(fullPath)
      }
    },
    visibleChildRoutes(route) {
      return route.children.filter(child => !child.hidden)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-menu {
  position: relative;
  top: 2px;
  // position: fixed;
  // top: var(--layout-header-nav-height);
  // left: 0;
  // right: 0;
  // z-index: 199;
  // background: var(--theme-nav-first-bg);
  // border-bottom: 1px solid var(--color-border);

  .el-menu.el-menu.el-menu {
    border-bottom: none;
  }
  .el-menu--horizontal {
    height: var(--top-menu-height);
    line-height: var(--top-menu-height);
    .el-menu-item{
      height: var(--top-menu-height);
      line-height: var(--top-menu-height);
      display: flex;
      align-items: center;
      .svg-icon{
        margin-right: 8px;
      }
    }
    .el-submenu{
        height: var(--top-menu-height);
        line-height: var(--top-menu-height);
        ::v-deep .el-submenu__title {
          height: var(--top-menu-height);
          line-height: var(--top-menu-height);
          display: flex;
          align-items: center;
          .svg-icon{
            margin-right: 8px;
          }
        }

    }


  }


}
.el-menu--horizontal .el-menu-item{
    display: flex;
    align-items: center;
    .svg-icon{
      margin-right: 4px;
    }
}
</style>
